module.exports = __webpack_public_path__ + "img/Img5b_204723_EeBr-9-6.123c01a4.jpg";